'use client';

import { useState, useEffect } from 'react';
import { WhatsAppService } from '../../../services/WhatsAppService';

export const WhatsAppManager = () => {
    const [status, setStatus] = useState({
        isConnected: false,
        qrCode: null,
        user: null,
        loading: true,
    });

    const [form, setForm] = useState({
        phone: '',
        message: '',
    });

    const [sending, setSending] = useState(false);
    const [alert, setAlert] = useState(null);

    // Polling Status WA setiap 3 detik
    const checkStatus = async () => {
        try {
            const res = await WhatsAppService.getStatus();
            const data = res.data; // atau res tergantung wrapper ApiService Anda
            setStatus({
                isConnected: data.is_connected,
                qrCode: data.qr_code,
                user: data.user,
                loading: false,
            });
        } catch (err) {
            console.error('Failed to fetch WA status:', err);
        }
    };

    useEffect(() => {
        checkStatus();

        // Set interval polling
        const interval = setInterval(() => {
            checkStatus();
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    // Handle Kirim Manual
    const handleSend = async (e) => {
        e.preventDefault();
        setSending(true);

        try {
            const res = await WhatsAppService.sendManual({
                data: { phone: form.phone, message: form.message }
            });

            if (res.data.status) {
                setAlert({ type: 'success', text: 'Pesan berhasil terkirim!' });
                setForm({ phone: '', message: '' });
            }
        } catch (err) {
            setAlert({ type: 'error', text: 'Gagal mengirim pesan.' });
        } finally {
            setSending(false);
        }
    };

    // Handle Logout WA
    const handleLogout = async () => {
        // if (!confirm('Apakah Anda yakin ingin memutuskan perangkat WhatsApp?')) return;

        try {
            await WhatsAppService.logout();
            checkStatus();
        } catch (err) {
            console.error('Failed to logout:', err);
        }
    };

    if (status.loading) {
        return <div className="p-6 text-center text-gray-500">Memuat status WA Gateway...</div>;
    }

    return (
        <div className="max-w-xl mx-auto p-6 bg-white rounded-xl shadow-md space-y-6">
            <h2 className="text-2xl font-bold text-gray-800 border-b pb-3">
                Radius Trend - WA Gateway
            </h2>

            {/* STATUS KONEKSI & SCANNER */}
            {status.isConnected ? (
                <div className="bg-green-50 border border-green-200 p-4 rounded-lg space-y-3">
                    <div className="flex items-center justify-between">
                        <span className="flex items-center gap-2 text-green-700 font-semibold">
                            <span className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></span>
                            WhatsApp Terhubung
                        </span>
                        <button
                            onClick={handleLogout}
                            className="text-xs bg-red-500 hover:bg-red-600 text-white px-3 py-1.5 rounded transition"
                        >
                            Disconnect / Logout
                        </button>
                    </div>
                    {status.user && (
                        <div className="text-sm text-gray-600 border-t border-green-200 pt-2">
                            <p>Akun: <strong className="text-gray-800">{status.user.name}</strong></p>
                            <p>Nomor: <span className="text-gray-800">+{status.user.phone}</span></p>
                        </div>
                    )}
                </div>
            ) : (
                <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-lg text-center space-y-3">
                    <p className="text-sm text-yellow-800 font-medium">
                        Silakan scan QR Code menggunakan aplikasi WhatsApp di HP Anda:
                    </p>
                    {status.qrCode ? (
                        <div className="p-3 bg-white inline-block rounded-lg shadow-sm">
                            <img
                                src={status.qrCode}
                                alt="WhatsApp QR Code"
                                className="w-60 h-60 mx-auto"
                            />
                        </div>
                    ) : (
                        <div className="py-8 text-gray-500 text-sm animate-pulse">
                            Menyiapkan QR Code baru...
                        </div>
                    )}
                </div>
            )}

            {/* FORM TEST KIRIM PESAN MANUAL */}
            {status.isConnected && (
                <form onSubmit={handleSend} className="space-y-4 pt-4 border-t">
                    <h3 className="text-lg font-semibold text-gray-700">Kirim Pesan Manual</h3>

                    {alert && (
                        <div
                            className={`p-3 rounded text-sm ${alert.type === 'success'
                                ? 'bg-green-100 text-green-800'
                                : 'bg-red-100 text-red-800'
                                }`}
                        >
                            {alert.text}
                        </div>
                    )}

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Nomor WhatsApp Tujuan
                        </label>
                        <input
                            type="text"
                            placeholder="Contoh: 081234567890"
                            value={form.phone}
                            onChange={(e) => setForm({ ...form, phone: e.target.value })}
                            required
                            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Isi Pesan / Tagihan
                        </label>
                        <textarea
                            rows="4"
                            placeholder="Ketik pesan invoice di sini..."
                            value={form.message}
                            onChange={(e) => setForm({ ...form, message: e.target.value })}
                            required
                            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={sending}
                        className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 rounded-lg transition disabled:opacity-50"
                    >
                        {sending ? 'Mengirim Pesan...' : 'Kirim WhatsApp'}
                    </button>
                </form>
            )}
        </div>
    );
}